// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaPhoneAlt, 
  FaWhatsapp, 
  FaMapMarkerAlt, 
  FaEnvelope, 
  FaInstagram, 
  FaFacebook,
  FaYoutube 
} from 'react-icons/fa';
import '../styles/footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-container">
                <img 
                  src="/whatsApp_DP.jpg" 
                  alt="Mahalakshmi Cabs" 
                  className="logo-icon-image"
                />
              </div>
              <div className="logo-text">
                <h3>Mahalakshmi Cabs</h3>
                <p>Kodaikanal Taxi Service</p>
              </div>
            </div>
            <p className="footer-description">
              Best taxi service in Kodaikanal with experienced drivers.
            </p>
            
            {/* Social Media Icons */}
            <div className="social-icons">
              <a href="mailto:info@mahalakshmicabs.com" className="social-icon" title="Email">
                <FaEnvelope />
              </a>
              <a href="https://instagram.com/mahalakshmicabs" target="_blank" rel="noopener noreferrer" className="social-icon" title="Instagram">
                <FaInstagram />
              </a>
              <a href="https://facebook.com/mahalakshmicabs" target="_blank" rel="noopener noreferrer" className="social-icon" title="Facebook">
                <FaFacebook />
              </a>
              <a href="https://youtube.com/@mahalakshmicabs" target="_blank" rel="noopener noreferrer" className="social-icon" title="YouTube">
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/cars">Our Fleet</Link></li>
              <li><Link to="/tours">Tour Packages</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4>Contact Us</h4>
            <div className="contact-items">
              <div className="contact-item">
                <FaPhoneAlt />
                <div className="contact-numbers">
                  <a href="tel:+918883377920">88833 77920</a>
                  <a href="tel:+918438568508">84385 68508</a>
                </div>
              </div>
              <div className="contact-item">
                <FaWhatsapp />
                <a href="https://wa.me/918883377920" target="_blank" rel="noopener noreferrer">
                  WhatsApp Booking
                </a>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span>Anna Salai, Kodaikanal</span>
              </div>
              <div className="contact-item">
                <FaEnvelope />
                <a href="mailto:info@mahalakshmicabs.com">
                  info@mahalakshmicabs.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Creator Credit */}
        <div className="creator-credit">
  <span className="credit-text">Website designed & developed by</span>
  <a 
    href="https://yevorasolutions-co.web.app/" 
    target="_blank" 
    rel="noopener noreferrer"
    className="creator-link"
  >
    <img 
      src="/yevora_logo.png" 
      alt="Yevora Solutions" 
      className="company-logo"
    />
  </a>
</div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <Link to="/terms">Terms & Conditions</Link>
            <span className="separator">|</span>
            <Link to="/privacy">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/gallery">Gallery</Link>
            <span className="separator">|</span>
            <Link to="/reviews">Reviews</Link>
            <span className="separator">|</span>
            <Link to="/faq">FAQs</Link>
          </div>
          <p className="copyright">
            &copy; {currentYear} Mahalakshmi Cabs. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;